import { Button } from '@cian/ui-kit';
import { TButtonTheme } from '@cian/ui-kit/button/types';
import { IconToggleHeartOff16, IconToggleHeartOn16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

export interface IFavoriteButtonProps {
  onClick(event: React.MouseEvent): void;
  theme?: TButtonTheme;
  isFavorite: boolean;
}

export function FavoriteButton({ isFavorite, onClick, theme = 'fill_white_secondary' }: IFavoriteButtonProps) {
  const icon = isFavorite ? (
    <IconToggleHeartOn16 color="icon-negative-default" />
  ) : (
    <IconToggleHeartOff16 color="icon-negative-default" />
  );
  const label = isFavorite ? 'В избранном' : 'В избранное';

  return (
    <Button theme={theme} onClick={onClick} beforeIcon={icon} size="XS">
      {label}
    </Button>
  );
}
